import axiosInstance from './axios.service';

const paymentMethodService = {
  // Public — all active methods; pass showInHome=true to filter for the homepage section
  getActiveMethods: async ({ showInHome } = {}) => {
    const params = showInHome ? '?showInHome=true' : '';
    const { data } = await axiosInstance.get(`/api/payment-methods/active${params}`);
    return data;
  },
  // Admin — all methods
  getAllMethods: async () => {
    const { data } = await axiosInstance.get('/api/payment-methods');
    return data;
  },
  createMethod: async payload => {
    const { data } = await axiosInstance.post('/api/payment-methods', payload);
    return data;
  },
  updateMethod: async (id, payload) => {
    const { data } = await axiosInstance.put(`/api/payment-methods/${id}`, payload);
    return data;
  },
  deleteMethod: async id => {
    const { data } = await axiosInstance.delete(`/api/payment-methods/${id}`);
    return data;
  },
};

export default paymentMethodService;
